// frontend/src/utils/prodConsoleSilencer.ts
// Purpose: Reduce console noise in production environment only.
// - No-op console.debug/log/info/table/trace/group/groupCollapsed/time/timeEnd in prod
// - Preserve console.warn and console.error
// - Auto-bypass when debug is explicitly enabled (query ?debug=1 or localStorage.enableDebugPanel = '1')

import { getEnvVar } from '../api/config';

(function setupProdConsoleSilencer() {
  try {
    // Determine if we are running in the logical prod environment
    // We rely on VITE_ENV provided via Infisical to distinguish dev vs prod deploys.
    const viteEnv = (getEnvVar('VITE_ENV') || '').toLowerCase();
    const isProdEnv = viteEnv === 'production';

    if (!isProdEnv) return;

    // Allow explicit opt-in debug in prod
    let debugEnabled = false;
    try {
      const qs = typeof window !== 'undefined' ? window.location.search : '';
      if (/([?&])debug=1(?!\d)/.test(qs)) debugEnabled = true;
    } catch {}
    try {
      if (typeof localStorage !== 'undefined' && localStorage.getItem('enableDebugPanel') === '1') {
        debugEnabled = true;
      }
    } catch {}

    if (debugEnabled) return;

    const c = window.console as Console & { __orig?: Partial<Console> };
    if (!c) return;

    // Save originals once
    if (!('__orig' in c)) {
      c.__orig = {
        log: c.log,
        debug: c.debug,
        info: c.info,
        table: (c as any).table,
        trace: c.trace,
        group: c.group,
        groupCollapsed: c.groupCollapsed,
        groupEnd: c.groupEnd,
        time: c.time,
        timeEnd: c.timeEnd,
      } as Partial<Console>;
    }

    // No-op the noisy methods
    const noop = () => {};
    c.log = noop as any;
    c.debug = noop as any;
    c.info = noop as any;
    (c as any).table = noop as any;
    c.trace = noop as any;
    c.group = noop as any;
    c.groupCollapsed = noop as any;
    c.groupEnd = noop as any;
    c.time = noop as any;
    c.timeEnd = noop as any;
  } catch {
    // Silently ignore any setup errors
  }
})();

export {};

